// Convert hex → HSL (H S% L%) string suitable for Tailwind CSS variables.
export function hexToHslString(hex) {
  if (!hex || typeof hex !== "string") return "222 47% 11%";
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return "222 47% 11%";
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let hh = 0;
  const l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  if (d !== 0) {
    if (max === r) hh = ((g - b) / d) % 6;
    else if (max === g) hh = (b - r) / d + 2;
    else hh = (r - g) / d + 4;
  }
  hh = Math.round(hh * 60);
  if (hh < 0) hh += 360;
  return `${hh} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyBrandColor(hex) {
  const hsl = hexToHslString(hex);
  document.documentElement.style.setProperty("--primary", hsl);
  document.documentElement.style.setProperty("--ring", hsl);
}

export const brandPresets = [
  { name: "Charcoal", hex: "#0F172A" },
  { name: "Indigo", hex: "#4F46E5" },
  { name: "Blue", hex: "#2563EB" },
  { name: "Emerald", hex: "#059669" },
  { name: "Orange", hex: "#EA580C" },
  { name: "Red", hex: "#DC2626" },
  { name: "Harissa", hex: "#E63946" },
  { name: "Purple", hex: "#7C3AED" },
  { name: "Pink", hex: "#DB2777" },
  { name: "Slate", hex: "#475569" },
];
